import React from "react";
import SectionArticleOrEventCards from "../../../containers/sections/SectionArticleOrEventCards";
import { useStaticData } from "../../../hooks/useStaticData";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";
import * as styles from "./SectionVolunteeringRoleLookup.module.scss";

export interface SectionVolunteeringRoleLookupProps {
	heading: string;
	jumpLinksTitle?: string;
}

export const getSectionVolunteeringRoleLookupProps = ({
	field_front_end_title,
	field_jump_links_title,
}: Queries.SectionDataFragment): SectionVolunteeringRoleLookupProps => ({
	heading: field_front_end_title,
	jumpLinksTitle: field_jump_links_title,
});

// TODO - TEST STATIC

const SectionVolunteeringRoleLookup: React.FC<
	SectionVolunteeringRoleLookupProps
> = ({ heading, jumpLinksTitle }) => {
	const { volunteerRoles } = useStaticData(["volunteerRoles"]);

	return (
		<WrappedSection
			sectionName="SectionVolunteeringRoleLookup"
			sectionColour={Colours.SANDY_FUR}
		>
			<div className={styles.lookupwithctainner}>
				<div className={styles.lookupwithctacontainer}>
					<div className={styles.lookupwithctatitle}>
						{jumpLinksTitle ? (
							<h2 className={styles.title} data-jumplinkstitle={jumpLinksTitle}>
								{heading}
							</h2>
						) : (
							<h2 className={styles.title}>{heading}</h2>
						)}
					</div>
					<SectionArticleOrEventCards
						forceFlatCards={false}
						displayOption={"loader"}
						showMoreLimit={20}
						items={volunteerRoles}
						noWrapper
					/>
				</div>
			</div>
		</WrappedSection>
	);
};

export default SectionVolunteeringRoleLookup;
